<template>
  <div class="dialog-success" v-show="show">
    <div class="dialog-success__content">
      <div class="dialog-success__close" @click="$emit('update:show', false)">
        <img :src="require('@/assets/images/icon-close.svg')" />
      </div>
      <div class="dialog-success__tips">
        <div class="dialog-success__title">提交成功</div>
        <div class="dialog-success__desc">客服人员e小宝将在1个工作日内与您取得联系开通使用哟~</div>
      </div>
      <div class="dialog-success__code">
        <div class="code-line">
          <div class="text">关注专属顾问</div>
          <hr />
        </div>
        <div class="text-desc">获取1份数字化报告</div>
        <div class="code-img">
          <img :src="code.img" alt="" />
        </div>
        <div class="code-tips">请截图后再微信中打开<br />并长按识别图中二维码</div>
      </div>
      <div class="dialog-success__entries">
        <div class="line">
          <div class="text">您还可以通过以下方式了解我们的产品</div>
          <hr />
        </div>
        <div class="entry-icons">
          <div class="icon-item" v-for="(entry, index) in entries" :key="index">
            <a :href="entry.url">
              <img :src="entry.img" alt="icon" class="entry-icon" />
            </a>
            <div class="entry-title">{{ entry.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },
  data() {
    return {
      code: {
        url: 'https://www.esign.cn/',
        img: require('@/assets/images/code.png'),
        title: '二维码',
      },
      entries: [
        {
          url: 'https://h5.esign.cn/download?pub=null',
          img: require('@/assets/images/download-app.png'),
          title: '下载APP',
        },
        {
          url: 'https://www.esign.cn/',
          img: require('@/assets/images/official-page.png'),
          title: '官网查看',
        },
        {
          url: 'https://h5.esign.cn/usercenterFront/regist?pub=esign',
          img: require('@/assets/images/register.png'),
          title: '注册体验',
        },
      ],
    }
  },
}
</script>
<style lang="less" scoped>
.dialog-success {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.45);

  &__content {
    width: 90%;
    position: relative;
    background-color: #fff;
    border-radius: 18px;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
  }

  @closeSize: 20px;

  &__close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: @closeSize;
    height: @closeSize;
    font-size: @closeSize;
    text-align: center;
    color: #888;

    img {
      width: @closeSize;
      height: @closeSize;
    }
  }

  &__tips {
    height: 150px;
    background-image: url('../../../../assets/images/bg-dialog-success.png'), linear-gradient(#fff, #ffece6);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: right;
    padding: 57px 15px 0;
    border-radius: 18px 18px 0 0;
  }

  &__title {
    color: #111;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  &__desc {
    color: #888;
    width: 65%;
    font-size: 12px;
    line-height: 20px;
  }
  &__code {
    font-size: 12px;
    text-align: center;
    .code-img {
      margin: 8px;
      > img {
        width: 100px;
        height: 100px;
        margin: 0 auto;
      }
    }
    .code-tips {
      color: #a5a5a5;
      line-height: 16px;
    }
    .code-line {
      margin: 16px 0 9px;
      > hr {
        min-width: 200px;
        width: 90%;
        height: 1px;
        margin: -7px auto 0;
        border: 0;
        z-index: 0;
        background-image: linear-gradient(to right, #fff 0%, #ddd 40%, #ddd 60%, #fff 100%);
      }
    }
    .text {
      background-color: #fff;
      padding: 0 15px;
      width: 108px;
      margin: 0 auto;
      z-index: 1;
      position: relative;
    }
    .text,
    .text-desc {
      font-weight: 600;
      color: #202640;
    }
  }
  &__entries {
    padding-bottom: 80px;
    background-color: #fff;
    padding: 0 10px 20px;
    border-radius: 0 0 18px 18px;

    .line {
      margin: 18px 0 24px;

      .text {
        background-color: #fff;
        padding: 0 8px;
        font-size: 12px;
        color: #383838;
        text-align: center;
        width: 228px;
        margin: 0 auto;
        z-index: 1;
        position: relative;
      }

      > hr {
        width: 400px;
        max-width: 90%;
        height: 1px;
        margin: -8px auto 0;
        border: 0;
        z-index: 0;
        background-image: linear-gradient(to right, #fff 0%, #ddd 15%, #ddd 85%, #fff 100%);
      }
    }

    .entry-icons {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
    }

    @entry-icon-size: 47px;
    .entry-icon {
      width: @entry-icon-size;
      height: @entry-icon-size;
      margin: 0 auto 12px;
    }

    .entry-title {
      font-size: 14px;
      color: #383838;
      text-align: center;
    }
  }
}
</style>
